<template>
    <b-modal @show="onShow" @ok="onOk" :no-close-on-backdrop="true" size="lg" :title="$t('select_item')" ref="innermodal">
        <table class="table table-bordered table-sm no-bor v-top">
            <thead>
                <tr>
                    <th class="text-center" style="width: 20px;"><input type="checkbox" v-model="checkAll"></th>
                    <th>{{$t('item_code')}}</th>
                    <th>{{$t('item_name')}}</th>
                    <th>{{$t('uom_name')}}</th>
                    <th>{{$t('qty')}}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(ret,index) in records" :key="index">
                    <td class="text-center"><input type="checkbox" v-model="ret.Checked"></td>
                    <td>{{ret.ItemCode}}</td>
                    <td>{{ret.ItemName}}</td>
                    <td class="text-right">{{ret.Quantity}}</td>
                    <td>{{ret.UomName}}</td>
                </tr>
            </tbody>
        </table>
    </b-modal>
</template>
<script>
import { Inventory } from '../../shared/models/model';
export default {
    props: {
        vBranchId: {
            type: String,
            default: ''
        },
        vItemIds: {
            type: Array,
            default: () => { return [];}
        }
    },
    data(){
        return {
            query: {
                CompanyId: this.$store.state.company.Id,
                BranchId: this.vBranchId,
                ExcludeIds: this.vItemIds
            },
            checkAll: false,
            records: []
        }
    },
    methods: {
        toList(){
            Inventory.selectItemOnhand(this.query).then(res => {
                this.records = res.Json.Items;
            });
        },
        onShow(){
            this.checkAll = false;
            this.toList();
        },
        onOk(){
            let itemSelected = this.records.filter(el => el.Checked == true);
            this.$emit('selected', itemSelected);
        }
    },
    watch: {
        vBranchId(value){
            this.query.BranchId = value;
        },
        vItemIds(value){
            this.query.ExcludeIds = value;
        },
        checkAll(value){
            this.records.forEach(el => {
                el.Checked = value;
            });
        }
    }
}
</script>